import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Linking,
  Alert,
} from "react-native";
import Text from "@components/AppText";
import Share from "react-native-share";
import CallIcon from "@assets/svg/Call";
import WhatsappDefault from "@assets/svg/WhatsappDefault";
import FraudIcon from "@assets/svg/FraudIcon";
import { CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import t from "@constants/localization";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import color from "@constants/color";
import { s } from "@utils/metrics_1";
import { verticalScale, scale } from "../../utils/scale";
import HomeIcon from "../../assets/svg/HomeIcon";
import PhoneIcon from "../../assets/svg/PhoneIcon";

const PATH = "screens/CustomerProfile/UserInfoCard";
const PATH2 = "WhatsAppAlert";

const UserInfoCard = ({
  address,
  navigation,
  user,
  handleNewOrderClick,
  fetched,
  isDeletedOrNotAddedCustomer,
  isfraudCustomer,
  setShowFraudModal = () => {},
  isloading,
}) => {
  const { user_phone = "" } = user || {};
  const onPressCall = () => {
    handleCallButtonPress(user_phone, CUSTOMER_PAGE.CX_DETAIL_CALL, {
      cx_id: user.user_id,
    });
  };

  const onPressWhatsapp = async () => {
    const { isInstalled: haveWhatsApp } =
      await Share.isPackageInstalled("com.whatsapp");
    if (!haveWhatsApp) {
      Alert.alert(
        t(`${PATH2}/title`),
        t(`${PATH2}/message`),
        [
          {
            text: t(`${PATH2}/onCloseText`),
            onClose: () => {},
          },
        ],
        { cancelable: true },
      );
    } else {
      analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_MESSAGE, {
        cx_id: user.user_id,
      });
      Linking.openURL(`whatsapp://send?phone=+91${user_phone}`);
    }
  };
  return (
    <View style={styles.container}>
      <View style={styles.behaveLikeRow}>
        <PhoneIcon />
        <View style={styles.textContainer}>
          <Text
            bold
            style={{
              color: "rgba(0, 0, 0, 0.56)",
              fontSize: scale(13),
              lineHeight: 24,
            }}
          >
            {user_phone ? `+ 91 - ${user_phone}` : "-"}
          </Text>
        </View>
      </View>
      <View
        style={[
          styles.behaveLikeRow,
          { marginVertical: 5, alignItems: address ? "flex-start" : "center" },
        ]}
      >
        <HomeIcon />
        <View style={styles.textContainer}>
          <Text
            style={{
              color: "rgba(0, 0, 0, 0.56)",
              fontSize: scale(14),
              lineHeight: 24,
            }}
          >
            {address
              .split(" ")
              .filter((word) => word !== "")
              .join(" ") || "-"}
          </Text>
          {fetched ? (
            address ? null : (
              <TouchableOpacity
                testID="ca-btn"
                onPress={() =>
                  navigation.navigate("AddressScreen", {
                    reasons: [],
                    onlySubmit: true,
                    goToApp: true,
                  })
                }
                style={{
                  width: scale(140),
                  height: verticalScale(30),
                  marginTop: 3,
                  backgroundColor: "#E40046",
                  borderRadius: 6,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    fontWeight: "600",
                    fontSize: scale(14),
                  }}
                >
                  {t(`${PATH}/enterYourAdd`)}
                </Text>
              </TouchableOpacity>
            )
          ) : null}
        </View>
      </View>
      <View style={styles.buttonsContainer}>
        <TouchableOpacity
          testID="cc-btn"
          style={[
            styles.button,
            {
              backgroundColor: "transparent",
              flexDirection: "column",
              borderWidth: 0,
              borderColor: "rgba(0,0,0,.5)",
            },
          ]}
          onPress={() => onPressCall()}
        >
          <View style={{ height: scale(20) }}>
            <CallIcon strokeColor="rgba(0,0,0,.8)" />
          </View>
          <Text
            style={{
              color: "rgba(0,0,0,.8)",
              fontSize: scale(14),
              marginLeft: 10,
            }}
          >
            {t(`${PATH}/call`)}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          testID="cw-btn"
          style={[
            styles.button,
            { backgroundColor: "transparent", flexDirection: "column" },
          ]}
          onPress={() => onPressWhatsapp()}
        >
          <View style={{ height: scale(20) }}>
            <WhatsappDefault />
          </View>
          <Text
            fontType="content1"
            style={{
              color: "rgba(0,0,0,.86)",
              fontSize: scale(14),
              marginLeft: 10,
            }}
          >
            {t(`${PATH}/sendMsg`)}
          </Text>
        </TouchableOpacity>
      </View>

      {isloading ? null : (
        <>
          <View style={styles.line} />
          <TouchableOpacity
            testID="cf-btn"
            onPress={isfraudCustomer ? null : () => setShowFraudModal(true)}
            activeOpacity={isfraudCustomer ? 1 : 0.2}
          >
            <View
              style={
                isfraudCustomer ? styles.fraudButton : styles.markFraudButton
              }
            >
              <FraudIcon />
              <Text style={styles.fraudText}>
                {" "}
                {isfraudCustomer
                  ? t(`${PATH}/fraudReported`)
                  : t(`${PATH}/reportFraud`)}
              </Text>
            </View>
          </TouchableOpacity>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  behaveLikeRow: {
    flexDirection: "row",
    marginVertical: 5,
    alignItems: "flex-start",
  },
  textContainer: {
    paddingHorizontal: 10,
    width: "90%",
  },
  container: {
    backgroundColor: "#fff",
    padding: 10,
    elevation: 1,
    borderRadius: 10,
    alignSelf: "center",
    marginBottom: verticalScale(5),
    position: "absolute",
    top: verticalScale(120),
    height: "auto",
    minHeight: verticalScale(180),
    shadowColor: "black",
    shadowOpacity: 0.0006,
    width: "92%",
    shadowOffset: {
      width: 0.1,
      height: 0.1,
    },
  },
  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    paddingTop: 16,
  },
  button: {
    height: verticalScale(45),
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  line: {
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: color.lightGrey,
  },
  fraudButton: {
    backgroundColor: color.lightRed,
    borderColor: color.primary,
    borderWidth: 1,
    borderRadius: 4,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 8,
  },
  markFraudButton: {
    marginTop: 6,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 2,
  },
  fraudText: {
    marginLeft: s.xs,
    color: color.primary,
    fontSize: 14,
  },
});

export default UserInfoCard;
